const dynamicPackage = {
  detailedPlan: "Detailed Plan",
  minimum: "Minimum",
  maximum: "Maximum",
};

export default dynamicPackage;
